import { EsmProjectEditor } from "@proof/authoring";
import { useEsmAccess } from "./FeatureAccess";
export function EsmProjectIntegration() {
  if (!useEsmAccess()) return null;
  return (
    <>
      <section className="panel padded">
        <h2>Connect your ESM application</h2>
        <p>
          Convert your ESM tables to JSON with the .NET package, load them
          below, and export your edits. Your application translates the returned
          JSON back to tables and saves them in its database transaction.
        </p>
        <a
          className="button"
          href="/downloads/ProofStudio.Esm.0.1.9.nupkg"
          download
        >
          Download NuGet package
        </a>
        <details>
          <summary>Embed the ESM project editor</summary>
          <p>
            The NuGet package copies all browser modules and designer runtime
            assets into your published ASP.NET site. Enable static files and load
            the editor locally using this example.
          </p>
          <pre>{`<script type="module" src="/proof-studio/plugins/esm-project.mjs"></script>
<proof-esm-project id="editor"></proof-esm-project>
<script>
customElements.whenDefined("proof-esm-project").then(() => {
  const editor = document.getElementById("editor");
  editor.options = { projectId: 7 };
  editor.value = hostEsmJson;
  editor.onSave = async ({ esm }) => {
    await saveThroughYourBackend(esm);
  };
});
</script>`}</pre>
        </details>
      </section>
      <EsmProjectEditor />
    </>
  );
}
